import {
  HANDLE_SITE_NAME_FILTER_CONTROL_PANEL,
  HANDLE_SELECTED_SITES_FILTER_CONTROL_PANEL,
  HANDLE_DATE_RANGE_CONTROL_PANEL,
  HANDLE_PRODUCTS_CONTROL_PANEL,
  HANDLE_ASSET_NAME_FILTER_CONTROL_PANEL,
  HANDLE_SELECTED_ASSETS_FILTER_CONTROL_PANEL,
  HANDLE_ASSETS_LIST,
  HANDLE_SITES_LIST,
  HANDLE_SEARCH_ASSETS_BY_SITES_FLAG,
  HANDLE_SEARCH_SITES_BY_ASSETS_FLAG,
  HANDLE_EXPORT_QUERY,
  HANDLE_ACTIVATE_FILTER_FLAG,
  HANDLE_DEACTIVATE_FILTER_FLAG,
} from '../types/types'

export const setSelectedSitesFilterControlPanel = (selectedSites) => ({
  type: HANDLE_SELECTED_SITES_FILTER_CONTROL_PANEL,
  payload: { selectedSites },
})

export const setSelectedAssetsFilterControlPanel = (selectedAssets) => ({
  type: HANDLE_SELECTED_ASSETS_FILTER_CONTROL_PANEL,
  payload: { selectedAssets },
})

export const setSiteNameFilterControlPanel = (siteName) => ({
  type: HANDLE_SITE_NAME_FILTER_CONTROL_PANEL,
  payload: { siteName },
})

export const setAssetNameFilterControlPanel = (assetName) => ({
  type: HANDLE_ASSET_NAME_FILTER_CONTROL_PANEL,
  payload: { assetName },
})

export const setDateRangeControlPanel = (data) => ({
  type: HANDLE_DATE_RANGE_CONTROL_PANEL,
  payload: { data },
})

export const setProductsControlPanel = (data) => ({
  type: HANDLE_PRODUCTS_CONTROL_PANEL,
  payload: { data },
})

export const setAssetsControlPanel = (assetsList) => ({
  type: HANDLE_ASSETS_LIST,
  payload: { assetsList },
})

export const setSitesControlPanel = (sitesList) => ({
  type: HANDLE_SITES_LIST,
  payload: { sitesList },
})

export const setSearchAssetsBySitesFlag = (assetsBySitesFlag) => ({
  type: HANDLE_SEARCH_ASSETS_BY_SITES_FLAG,
  payload: { assetsBySitesFlag },
})

export const setSearchSitesByAssetsFlag = (sitesByAssetsFlag) => ({
  type: HANDLE_SEARCH_SITES_BY_ASSETS_FLAG,
  payload: { sitesByAssetsFlag },
})

export const setExportQuery = (exportQuery) => ({
  type: HANDLE_EXPORT_QUERY,
  payload: { exportQuery },
})

export const setActivateFilterFlag = () => ({
  type: HANDLE_ACTIVATE_FILTER_FLAG,
  payload: {},
})

export const setDeactivateFilterFlag = () => ({
  type: HANDLE_DEACTIVATE_FILTER_FLAG,
  payload: {},
})
